module.exports = __webpack_public_path__ + "static/flags/AV-e42eb5e9f951d68f35caab0a3251e783.gif";